module.exports = __webpack_public_path__ + "static/media/sunset.2bff7d78.svg";